<p *ngIf="isVolumeDiscount">
  下記に表示されている「ボリューム割引」の金額は、本日時点の貴社の契約総数に応じた割引率により計算されております。<br />
  請求時点で契約総数に変動があった場合は割引率が再計算されます。
</p>
